import React, { ReactNode } from 'react';

export type ThemeProps = {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode;
};

export interface Theme {
  // Colors
  backgroundDefault: string;
  backgroundSecondary: string;
  primaryExtraDark: string;
  actionActive: string;
  textDisabled: string;
  primaryMain: string;
  primaryContrast: string;
  onlineStatusColor: string;
  offlineStatusColor: string;
  textPrimary: string;
  baseTableHeaderBg: string;

  // Fonts
  primaryFontSize: string;
  largeFontSize: string;
  smallFontSize: string;
}

// Adding default theme because of issue with theme consumption in app-manager
// https://stackoverflow.com/a/68974381/8815491
const defaultTheme: Theme = {
  backgroundDefault: '#FAFAFA',
  backgroundSecondary: '#f0f2f3',
  primaryExtraDark: '#0E2F6C',
  actionActive: '#595b65cc',
  textDisabled: '#1f1f1f66',
  primaryMain: '#3056D9',
  primaryContrast: '#FFFFFF',
  onlineStatusColor: '#28B865',
  offlineStatusColor: '#F44336',
  textPrimary: '#1F1F1FDE',
  baseTableHeaderBg: '#4CB4FA14',

  primaryFontSize: '0.8rem',
  largeFontSize: '1rem',
  smallFontSize: '0.6rem',
};

export const ThemeContext = React.createContext<Theme>(defaultTheme);
